import type { Theme } from '../../types/theme';

export const elevenlabsTheme: Theme = {
  id: 'elevenlabs',
  name: 'ElevenLabs',
  description: 'Dark cinematic UI with audio-waveform aesthetics for AI voice platform',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/elevenlabs/DESIGN.md',
  visualKeywords: ['dark', 'purple accent', 'audio-waveform', 'cinematic', 'AI voice'],
  colors: {
    background: '#0a0a0f',
    surface: '#141420',
    surfaceElevated: '#1e1e2a',
    textPrimary: '#ffffff',
    textSecondary: '#a0a0b0',
    textMuted: '#a0a0b0',
    border: '#2a2a3a',
    borderSubtle: '#343444',
    primary: '#9d4edd',
    primaryHover: '#ac5dec',
    primaryActive: '#7f30bf',
    accent: '#9d4edd',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'cinematic',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
